module.exports = __webpack_public_path__ + "static/media/w_w_hb_0.6ce10b37.png";